<i18n>
{
  "fr": {
    "administrations": "Tutelles",
    "disciplines": "Disciplines"
  },
  "en": {}
}
</i18n>

<template>
  <div v-if="laboratory">
    <div class="modal-card" style="width: 900px; height: auto">
      <section class="modal-card-body">
        <b-icon icon="flask" size="is-large"></b-icon>
        {{ laboratory.name }}

        <div class="columns">
          <div class="column">
            <entity-map :entity="laboratory" />
          </div>
          <div class="column">
            <b-notification :closable="false">
              <b-field :label="$t('administrations')">
                <b-taglist>
                  <b-tag
                    v-for="(adm, index) in laboratory.administrations"
                    :key="index"
                    icon="caret-right"
                    type="is-info"
                  >
                    {{ adm.name }}
                  </b-tag>
                </b-taglist>
              </b-field>
            </b-notification>
            <b-notification :closable="false">
              <b-field :label="$t('disciplines')">
                <b-taglist>
                  <b-tag
                    v-for="(disc, index) in laboratory.disciplines"
                    :key="index"
                    icon="caret-right"
                    type="is-info"
                  >
                    {{ disc.name }}
                  </b-tag>
                </b-taglist>
              </b-field>
            </b-notification>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LaboratoryView',
  components: {
    'entity-map': () => import('@/components/transition/AbstractEntityMap.vue')
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      // this is actually a laboratoy let's use this name
      laboratory: this.entity
    }
  },
  methods: {
    generateMailTo () {}
  }
}
</script>

<style></style>
